import { Container, Sprite, type Texture } from "pixi.js";
import { MERGE_LADDER, type LadderSymbolId } from "../assets/mergeLadder";

/**
 * The ladder bar above the grid, in composition-root units: 932 × 103 (the art's 9.05:1), its centre 564 above the
 * cells' centre, its bottom just over the frame's rim — the layout example's bar on its phone at the composition's 0.879
 * (its purple body 810 × 66 units there). Each symbol's icon sits between two of the bar's painted chevrons, where the
 * layout example puts it (the slot centres as shares of the bar's width, and each icon's drop below the bar's centre
 * line), all nine at one scale of their art, so they keep the sizes the artist drew them at (the blue sweet and the
 * chocolate smaller, the bear taller), as the example draws them.
 */
export const LADDER_GEOMETRY = {
  width: 932,
  height: 103,
  y: -564,
  iconScale: 0.42,
  slots: [0.07, 0.185, 0.289, 0.396, 0.5, 0.602, 0.719, 0.835, 0.937],
  slotDrops: [2.5, 2.5, 3.5, 6, 0, 2.5, 3, 2.5, 3],
} as const;

/** The merge ladder as the player reads it: the bar and the nine symbols in their merge order, left to right. */
export class LadderBarView extends Container {
  public constructor(input: { bar: Texture | null; icons: ReadonlyMap<LadderSymbolId, Texture> }) {
    super({ label: "LadderBar" });
    const g = LADDER_GEOMETRY;
    this.position.set(0, g.y);
    if (input.bar) {
      const bar = new Sprite({ texture: input.bar, anchor: 0.5, label: "Bar" });
      bar.setSize(g.width, g.height);
      this.addChild(bar);
    }
    MERGE_LADDER.forEach((symbolId, slot) => {
      const texture = input.icons.get(symbolId);
      if (!texture) return;
      const icon = new Sprite({ texture, anchor: 0.5, label: symbolId });
      icon.scale.set(g.iconScale);
      icon.position.set((g.slots[slot] - 0.5) * g.width, g.slotDrops[slot]);
      this.addChild(icon);
    });
  }
}
